import React from 'react'
import {ReactComponent as SearchIcon} from '../../../media/white_search_icon.svg'

const FiltrosSuscripcion = () => {
  const submit = (e: any) => {
    e.preventDefault()
  }

  return (
    <form onSubmit={submit}  className='mt-16'>
      <div className='listar-usuario-form-filter' style={{alignItems: 'end'}}>
        <div className='filter-field'>
          <label htmlFor='DateInit' className='field-label m'>
            Fecha inicial
          </label>
          <input autoComplete='off'
            type='date'
            className='m text-field normal w-input'
            maxLength={256}
            name='fechaInicial'
            data-name='DateInit'
            placeholder='Your last name'
            
            // onChange={handleInputChange}
            // onBlur={handleErrors}
            // value={formFilter.fechaInicial}
            // max={fechaActual}
            style={{minWidth: '185px'}}
          />
          {/* {errors.fechaInicial && <p className='alert s'>{errors.fechaInicial}</p>} */}
        </div>
        <div className='filter-field'>
          <label htmlFor='DateEnd' className='field-label m'>
            Fecha final
          </label>
          <input autoComplete='off'
            type='date'
            className='m text-field normal w-input'
            maxLength={256}
            name='fechaFinal'
            data-name='DateEnd'
            placeholder='Your last name'
            
            // onChange={handleInputChange}
            // onBlur={handleErrors}
            // value={formFilter.fechaFinal}
            // max={fechaActual}
            style={{minWidth: '185px'}}
          />
          {/* {errors.fechaFinal && <p className='alert s'>{errors.fechaFinal}</p>} */}
        </div>
        <div>
          <button type='submit' className='icon-button filter-search-btn'>
            <SearchIcon width={20} height={20} />
          </button>
        </div>
      </div>
    </form>
  )
}

export default FiltrosSuscripcion
